import React from 'react';
import { unescape } from 'lodash';

import style from '../index.module.css';

import Placeholder from '../../../static/images/placeholder.svg';
import ShoppingBag from '../../../static/images/shopping_bag.svg';

type MarketplaceCardProps = {
    artists?: Array<string>;
    attribution?: string;
    currency?: string;
    image?: string;
    imageAltText?: string;
    listPrice?: string;
    promoType: string;
    type?: string;
    title?: string;
    url?: string;
};

const MarketplaceCard = ({
    artists,
    attribution,
    currency,
    image,
    imageAltText,
    listPrice,
    promoType,
    type,
    title,
    url,
}: MarketplaceCardProps) => {
    return (
        <div className={style.cardPromo} data-type={promoType}>
            <div className={style.imageContainer}>
                {/* Remove tabindex so users don't have to tab through cards twice (they are both the same link) */}
                <a href={url} tabIndex={-1}>
                    <img src={image ? image : Placeholder} alt={imageAltText ? imageAltText : unescape(title)} />
                </a>
            </div>

            <div className="info">
                <a href={url}>
                    {artists?.length > 0 && (
                        <div className={`${style.creator} ${style.oneLineClamp}`}>
                            {attribution} {unescape(artists.join(', '))}
                        </div>
                    )}
                    <h3 className={`${style.title} ${artists?.length > 0 ? style.twoLineClamp : style.threeLineClamp}`}>
                        {unescape(title)}
                    </h3>

                    {type === 'Private Sale' ? (
                        <div className={style.cta}>Enquire</div>
                    ) : (
                        <>
                            {listPrice && currency && (
                                <div className={style.price}>
                                    {listPrice.toLocaleString()} {currency}
                                </div>
                            )}

                            <div className={style.cta}>
                                <ShoppingBag />
                                Buy now
                            </div>
                        </>
                    )}
                </a>
            </div>
        </div>
    );
};

export default MarketplaceCard;
